import { Button, FormGroup, Input, Label, Select, Textarea } from '@/components'
import { FlexWrapper } from '@/components/layout/flex/flexWrapper'
import { areaCd } from '@/constants/areaCd'
import { bizGubn } from '@/constants/bizGubn'
import { ntnCd } from '@/constants/ntnCd'
import { useAxios } from '@/context/axiosContext'
import { useDialog } from '@/context/dialogContext'
import { useRedis } from '@/hooks/useRedis'
import BizHist from '@/pages/bizMgmt/hist/bizHist'
import commonUtils from '@/utils/commonUtils'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Col, Row } from 'styled-bootstrap-grid'

type TInput = HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement

declare global {
  interface Window {
    kakao: any
  }
}
interface GetRequest {
  bizCd?: string //업체코드
}

interface BizDetailItem {
  cmpnyCd: string
  bizCd: string
  bizNm: string
  bizGubn: string
  ntnCd: string
  areaCd: string
  baseDomain: string
  chrgeDomain: string
  addr: string
  phone: string
  email: string
  useYn: string
  mshipYn: string
  batchYn: string
  manualYn: string
  uri: string
  rem: string
  schrTag: string
  cstRem: string
  regId: string
  regDate: string
  updId: string
  updDate: string
  newBatchYn: string
  coordinateX: string
  coordinateY: string
  holeType: string
  confidenceLvlCd: string
  userName: string
}

const DetailBizMgmt: React.FC = () => {
  const axios = useAxios()
  const navigate = useNavigate()
  const location = useLocation()
  const { showAlert, showConfirm } = useDialog()
  const { getComCodeValue, getComCodes } = useRedis()
  const [requestData] = useState({
    bizCd: String(location.state?.bizCd || ''),
  })

  const [bizDetailMap, setBizDetailMap] = useState<BizDetailItem>({
    addr: '',
    areaCd: '',
    baseDomain: '',
    batchYn: getComCodes('BATCH_YN')[0]?.code || 'N',
    bizCd: '',
    bizGubn: getComCodes('BIZ_CD')[0]?.code || '001',
    bizNm: '',
    chrgeDomain: '',
    cmpnyCd: '',
    coordinateX: '',
    coordinateY: '',
    cstRem: '',
    email: '',
    manualYn: getComCodes('MANUAL_YN')[0]?.code || 'Y',
    mshipYn: getComCodes('MSHIP_YN')[0]?.code || 'N',
    newBatchYn: getComCodes('NEW_BATCH_YN')[0]?.code || 'N',
    ntnCd: getComCodes('NTN_CD')[0]?.code || '082',
    phone: '',
    regDate: '',
    regId: '',
    rem: '',
    schrTag: '',
    updDate: '',
    updId: '',
    uri: '',
    useYn: getComCodes('USE_YN')[0]?.code || 'Y',
    holeType: '',
    confidenceLvlCd: getComCodes('CONFIDENCE_LVL_CD')[0]?.code || 'M',
    userName: '',
  })

  useEffect(() => {
    if (requestData.bizCd) {
      getBizDetail()
    }
  }, [])

  const handleInputChange = (e: React.ChangeEvent<TInput>) => {
    const { name, value } = e.target

    setBizDetailMap((prevState) => {
      //if (!prevState) return null

      return {
        ...prevState,
        [name]: value,
      } as BizDetailItem // 모든 필드를 포함하는 상태를 유지
    })
  }

  //업체상세조회
  const getBizDetail = async () => {
    try {
      const data: GetRequest = {
        bizCd: requestData.bizCd,
      }

      const response = await axios.get('/bizMgmt/detail', {
        params: { ...data },
      })

      const bizDetailMap = response.data
      setBizDetailMap(bizDetailMap)
    } catch (err: any) {
      console.error('Error fetching detailBiz:', err)
    }
  }

  //업체정보저장
  const updateBiz = async () => {
    try {
      if (!bizDetailMap?.bizNm) {
        showAlert({ title: '업체명을 입력해주세요' })
        return
      }

      if (!bizDetailMap?.bizGubn) {
        showAlert({ title: '업체구분을 선택해주세요' })
        return
      }

      if (!bizDetailMap?.ntnCd) {
        showAlert({ title: '국가코드를 선택해주세요' })
        return
      }

      if (!bizDetailMap?.areaCd) {
        showAlert({ title: '지역코드를 선택해주세요' })
        return
      }

      if (!bizDetailMap?.useYn) {
        showAlert({ title: '사용여부를 선택해주세요' })
        return
      }

      // if (!bizDetailMap?.batchYn) {
      //   showAlert({ title: '배치여부를 선택해주세요' })
      //   return
      // }

      if (!bizDetailMap?.mshipYn) {
        showAlert({ title: '회원제여부를 선택해주세요' })
        return
      }

      if (!bizDetailMap?.newBatchYn) {
        showAlert({ title: '배치여부를 선택해주세요' })
        return
      }

      const keys = Object.keys(bizDetailMap)

      let copyFlag = false
      for (let i = 0; i < keys.length; i++) {
        const elements = document.getElementById(keys[i])
        if (elements && elements.classList.contains('copy')) {
          copyFlag = true
          showAlert({
            title: '복사한 값을 확인해 주세요',
          })
          return
        }
      }
      if (copyFlag) {
        return
      }

      const response = await axios.post('/bizMgmt/update', bizDetailMap, {
        headers: {
          'Content-Type': 'application/json',
        },
      })

      //TODO. API에서 성공여부 코드로 보내기
      if (response.status === 200) {
        showAlert({
          type: 'success',
          title: '저장이 완료되었어요.',
          onClose() {
            // navigate('/bizMgmt')
            navigate('/bizMgmt', {
              state: {
                bizSearchState: location.state?.bizSearchState,
              },
            })
          },
        })
      } else {
        showAlert({
          title: '저장을 실패했어요. 잠시 후 다시 시도해 주세요.',
        })
      }
    } catch (err: any) {
      showAlert({
        title: '오류가 발생했어요. 잠시 후 다시 시도해주세요.',
      })
      console.error('Error updating biz:', err)
    }
  }

  const getCoordinate = async (addr: string) => {
    const coordinateX = document.getElementById('coordinateX')
    if (coordinateX) {
      coordinateX.classList.remove('copy')
    }
    const coordinateY = document.getElementById('coordinateY')
    if (coordinateY) {
      coordinateY.classList.remove('copy')
    }
    const geocoder = new window.kakao.maps.services.Geocoder()
    geocoder.addressSearch(addr, (result: any, status: any) => {
      if (status === window.kakao.maps.services.Status.OK) {
        setBizDetailMap((prevState) => {
          return {
            ...prevState,
            coordinateX: result[0].x,
            coordinateY: result[0].y,
          } as BizDetailItem // 모든 필드를 포함하는 상태를 유지
        })
      } else {
        showAlert({
          title: '좌표정보 가져오기 실패:' + status,
          type: 'error',
        })
      }
    })
  }

  const copyData = () => {
    requestData.bizCd = ''
    setBizDetailMap({
      ...bizDetailMap,
      bizCd: '',
    })

    const keys = Object.keys(bizDetailMap)
    const requireCheckList = [
      'bizNm',
      'coordinateX',
      'coordinateY',
      'rem',
      'cstRem',
    ]
    keys.forEach((key) => {
      if (!requireCheckList.includes(key)) {
        // requireCheckList 에 없는 값은 복사후 체크안함
        return
      }
      const elements: any = document.getElementById(key)
      if (elements && elements.value) {
        elements.classList.add('copy')
      }
    })
  }

  const removeCopyClass = (e: any) => {
    e.currentTarget.classList.remove('copy')
  }

  const handleAllDeleteClick = () => {
    showConfirm({
      title: '업체정보삭제',
      message:
        '⚠️ 업체정보를 완전히 삭제할까요?\n계속하려면 "삭제확인"라고 입력하세요.',
      confirmBtnName: '삭제하기',
      cancelBtnName: '취소',
      inputPlaceholder: '삭제확인',
      inputRequired: true,
      inputValidator: (value) => {
        return value === '삭제확인' || '"삭제확인"라고 정확히 입력하세요.'
      },
      onConfirm: (inputValue) => {
        deleteBizInfo()
      },
    })
  }

  const deleteBizInfo = async () => {
    const payload = {
      bizCd: requestData.bizCd,
      cmpnyCd: '001',
    }
    try {
      const response = await axios.post('/bizMgmt/delete', payload)
      if (response.status == 200) {
        showAlert({
          type: 'success',
          title: '삭제가 완료되었어요.',
          onClose() {
            navigate('/bizMgmt')
          },
        })
      } else {
        showAlert({
          title: '삭제를 실패했어요. 잠시 후 다시 시도해 주세요.',
        })
      }

      // if (response.status === 200) {
      //   showAlert({
      //     type: 'success',
      //     title: '삭제가 완료되었어요.',
      //     onClose() {
      //       navigate('/bizMgmt')
      //     },
      //   })
      // } else {
      //   showAlert({
      //     title: '삭제를 실패했어요. 잠시 후 다시 시도해 주세요.',
      //   })
      // }
    } catch (err: any) {
      console.error('Error fetching deleteComment:', err)
    }
  }

  return (
    <>
      <div
        style={{
          width: '77%',
          height: '100%',
          marginTop: '50px',
          margin: '0 auto',
        }}
      >
        <style>
          {`
            .copy {
              background-color: yellow;
            }
          `}
        </style>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            marginBottom: '10px',
            alignItems: 'center',
            marginTop: '50px',
          }}
        >
          <div style={{ display: 'flex', gap: '0.5rem', lineHeight: '2rem' }}>
            <p style={{ fontSize: '20px' }}>업체등록/수정</p>
            {requestData.bizCd && (
              <>
                <Button
                  color="neverbe"
                  variant="outlined"
                  size="xs"
                  onClick={() => {
                    showConfirm({
                      message: '업체정보를 복사하시겠습니까?',
                      onConfirm: () => {
                        copyData()
                      },
                    })
                  }}
                >
                  복사
                </Button>
                <Button
                  color="danger"
                  variant="contained"
                  size="xs"
                  onClick={handleAllDeleteClick}
                >
                  업체정보삭제
                </Button>
              </>
            )}
          </div>
          <FlexWrapper gap="10px">
            <Button
              onClick={() => {
                // const page = location.state?.prevPage
                // showConfirm({
                //   title: `${page === 'batch' ? '배치실패현황' : '업체관리'} 화면으로 이동할까요?`,
                //   onConfirm() {
                //     if (page === 'batch') {
                //       navigate(-1)
                //     } else {
                //       navigate('/bizMgmt', {
                //         state: {
                //           bizSearchState: location.state?.bizSearchState,
                //         },
                //       })
                //     }
                //   },
                // })
                const page = location.state?.prevPage
                if (page === 'batch') {
                  navigate(-1)
                } else {
                  navigate('/bizMgmt', {
                    state: {
                      bizSearchState: location.state?.bizSearchState,
                    },
                  })
                }
              }}
              color="neverbe"
              variant="outlined"
            >
              목록
            </Button>
            <Button
              onClick={() =>
                showConfirm({
                  title: '변경사항을 저장할까요?',
                  onConfirm() {
                    updateBiz()
                  },
                })
              }
              color="neverbe"
            >
              저장
            </Button>
          </FlexWrapper>
        </div>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="bizCd">
                업체코드
              </Label>
              <Input
                id="bizCd"
                name="bizCd"
                type="text"
                placeholder="업체코드는 자동 생성됩니다."
                maxLength={20}
                value={bizDetailMap?.bizCd || ''}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="bizNm">
                업체명
              </Label>
              <Input
                id="bizNm"
                name="bizNm"
                type="text"
                placeholder="업체명을 입력해주세요."
                maxLength={100}
                value={bizDetailMap?.bizNm || ''}
                disabled={false}
                onChange={handleInputChange}
                onClick={removeCopyClass}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="bizGubn">
                업체구분
              </Label>
              <Select
                id="bizGubn"
                name="bizGubn"
                value={bizDetailMap?.bizGubn || ''}
                onChange={handleInputChange}
                onClick={removeCopyClass}
              >
                {getComCodes('BIZ_CD').map((item) => (
                  <option key={item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="holeType">
                홀 유형
              </Label>
              <Select
                id="holeType"
                name="holeType"
                value={bizDetailMap?.holeType || ''}
                onChange={handleInputChange}
                onClick={removeCopyClass}
              >
                <option value="">선택</option>
                {getComCodes('HOLE_TYPE').map((item) => (
                  <option key={item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="ntnCd">
                국가코드
              </Label>
              <Select
                id="ntnCd"
                name="ntnCd"
                value={bizDetailMap?.ntnCd}
                onChange={handleInputChange}
                onClick={removeCopyClass}
              >
                {getComCodes('NTN_CD').map((item) => (
                  <option key={item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="areaCd">
                지역코드
              </Label>
              <Select
                id="areaCd"
                name="areaCd"
                value={bizDetailMap?.areaCd || ''}
                onChange={handleInputChange}
                onClick={removeCopyClass}
              >
                <option>선택</option>
                {getComCodes('AREA_CD')
                  .filter((item) => item.code !== '00') // 전국 제외
                  .map((item) => (
                    <option key={'areaCd' + item.code} value={item.code}>
                      {item.codeNm}
                    </option>
                  ))}
              </Select>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="baseDomain">
                기본도메인
              </Label>
              <Input
                id="baseDomain"
                name="baseDomain"
                type="text"
                placeholder="기본도메인을 입력해주세요."
                maxLength={200}
                value={bizDetailMap?.baseDomain || ''}
                disabled={false}
                onChange={handleInputChange}
                onClick={removeCopyClass}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="chrgeDomain">
                가격도메인
              </Label>
              <Input
                id="chrgeDomain"
                name="chrgeDomain"
                type="text"
                placeholder="가격도메인을 입력해주세요."
                maxLength={1000}
                value={bizDetailMap?.chrgeDomain || ''}
                disabled={false}
                onChange={handleInputChange}
                onClick={removeCopyClass}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={8}>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="addr">
                주소
              </Label>
              <Input
                id="addr"
                name="addr"
                type="text"
                placeholder="주소를 입력해주세요."
                maxLength={200}
                value={bizDetailMap?.addr || ''}
                disabled={false}
                onChange={handleInputChange}
                onClick={removeCopyClass}
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="coordinate">
                좌표정보
              </Label>
              <FlexWrapper gap="10px">
                <Input
                  id="coordinateX"
                  name="coordinateX"
                  type="number"
                  placeholder=""
                  step={0.0001}
                  value={bizDetailMap?.coordinateX || ''}
                  onChange={handleInputChange}
                  onClick={removeCopyClass}
                />
                <Input
                  id="coordinateY"
                  name="coordinateY"
                  type="number"
                  placeholder=""
                  step={0.0001}
                  value={bizDetailMap?.coordinateY || ''}
                  onChange={handleInputChange}
                  onClick={removeCopyClass}
                />
                <Button
                  onClick={() => {
                    getCoordinate(bizDetailMap?.addr || '')
                  }}
                  color="neverbe"
                  variant="outlined"
                >
                  📌
                </Button>
              </FlexWrapper>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="email">
                이메일
              </Label>
              <Input
                id="email"
                name="email"
                type="text"
                placeholder="이메일을 입력해주세요."
                maxLength={100}
                value={bizDetailMap?.email || ''}
                disabled={false}
                onChange={handleInputChange}
                onClick={removeCopyClass}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="phone">
                전화번호
              </Label>
              <Input
                id="phone"
                name="phone"
                type="text"
                placeholder="전화번호를 입력해주세요."
                maxLength={20}
                value={bizDetailMap?.phone || ''}
                disabled={false}
                onChange={handleInputChange}
                onClick={removeCopyClass}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="useYn">
                사용여부
              </Label>
              <Select
                id="useYn"
                name="useYn"
                value={bizDetailMap?.useYn || ''}
                onChange={handleInputChange}
                onClick={removeCopyClass}
              >
                {getComCodes('USE_YN').map((item) => (
                  <option key={'useYn' + item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="mshipYn">
                회원제여부
              </Label>
              <Select
                id="mshipYn"
                name="mshipYn"
                value={bizDetailMap?.mshipYn || ''}
                onChange={handleInputChange}
                onClick={removeCopyClass}
              >
                {getComCodes('MSHIP_YN').map((item) => (
                  <option key={'mshipYn' + item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
          </Col>
          {/* <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="batchYn">
                배치여부
              </Label>
              <Select
                id="batchYn"
                name="batchYn"
                value={bizDetailMap?.batchYn || ''}
                onChange={handleInputChange}
                onClick={removeCopyClass}
              >
                {getComCodes('BATCH_YN').map((item) => (
                  <option key={'batchYn' + item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
          </Col> */}
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="newBatchYn">
                배치여부
              </Label>
              <Select
                id="newBatchYn"
                name="newBatchYn"
                value={bizDetailMap?.newBatchYn || ''}
                onChange={handleInputChange}
                onClick={removeCopyClass}
              >
                {getComCodes('NEW_BATCH_YN').map((item) => (
                  <option key={'newBatchYn' + item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="manualYn">
                수기관리여부
              </Label>
              <Select
                id="manualYn"
                name="manualYn"
                value={bizDetailMap?.manualYn || ''}
                onChange={handleInputChange}
                onClick={removeCopyClass}
              >
                {getComCodes('MANUAL_YN').map((item) => (
                  <option key={'manualYn' + item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
          </Col>
          {/* <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="newBatchYn">
                신규배치여부
              </Label>
              <Select
                id="newBatchYn"
                name="newBatchYn"
                value={bizDetailMap?.newBatchYn || ''}
                onChange={handleInputChange}
                onClick={removeCopyClass}
              >
                {getComCodes('NEW_BATCH_YN').map((item) => (
                  <option key={'newBatchYn' + item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
          </Col> */}
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="confidenceLvlCd">
                정확도
              </Label>
              <Select
                id="confidenceLvlCd"
                name="confidenceLvlCd"
                value={bizDetailMap?.confidenceLvlCd || ''}
                onChange={handleInputChange}
                onClick={removeCopyClass}
              >
                {getComCodes('CONFIDENCE_LVL_CD').map((item) => (
                  <option key={'confidenceLvlCd' + item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="uri">
                URI
              </Label>
              <Input
                id="uri"
                name="uri"
                type="text"
                placeholder="URI를 입력해주세요."
                maxLength={200}
                value={bizDetailMap?.uri || ''}
                disabled={false}
                onChange={handleInputChange}
                onClick={removeCopyClass}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="rem">
                비고
              </Label>
              <Textarea
                id="rem"
                name="rem"
                value={bizDetailMap?.rem || ''}
                onChange={handleInputChange}
                onClick={removeCopyClass}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="rem">
                고객용비고
              </Label>
              <Textarea
                id="cstRem"
                name="cstRem"
                value={bizDetailMap?.cstRem || ''}
                onChange={handleInputChange}
                onClick={removeCopyClass}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="schrTag">
                검색어태그
              </Label>
              <Input
                id="schrTag"
                name="schrTag"
                type="text"
                placeholder="검색어태그를 입력해주세요."
                maxLength={200}
                value={bizDetailMap?.schrTag || ''}
                disabled={false}
                onChange={handleInputChange}
                onClick={removeCopyClass}
              />
            </FormGroup>
          </Col>
        </Row>
        {requestData.bizCd ? (
          <Row>
            <Col col>
              <FormGroup mb="20px">
                <Label display="block" mb="5px" htmlFor="regId">
                  등록자
                </Label>
                <Input
                  id="regId"
                  name="regId"
                  type="text"
                  maxLength={200}
                  value={bizDetailMap?.regId || ''}
                  disabled={true}
                />
              </FormGroup>
            </Col>
            <Col col>
              <FormGroup mb="20px">
                <Label display="block" mb="5px" htmlFor="regDate">
                  등록일시
                </Label>
                <Input
                  id="regDate"
                  name="regDate"
                  type="text"
                  maxLength={200}
                  value={commonUtils.formatDate(
                    bizDetailMap?.regDate || '',
                    true,
                  )}
                  disabled={true}
                />
              </FormGroup>
            </Col>
            <Col col>
              <FormGroup mb="20px">
                <Label display="block" mb="5px" htmlFor="updId">
                  수정자
                </Label>
                <Input
                  id="updId"
                  name="updId"
                  type="text"
                  maxLength={200}
                  value={
                    `${bizDetailMap?.userName} (${bizDetailMap?.updId})` || ''
                  }
                  disabled={true}
                />
              </FormGroup>
            </Col>
            <Col col>
              <FormGroup mb="20px">
                <Label display="block" mb="5px" htmlFor="updDate">
                  수정일시
                </Label>
                <Input
                  id="updDate"
                  name="updDate"
                  type="text"
                  maxLength={200}
                  value={commonUtils.formatDate(
                    bizDetailMap?.updDate || '',
                    true,
                  )}
                  disabled={true}
                />
              </FormGroup>
            </Col>
          </Row>
        ) : (
          <></>
        )}
      </div>
      {requestData.bizCd ? <BizHist></BizHist> : <></>}
    </>
  )
}

export default DetailBizMgmt
